import React, { useEffect, useRef, useState } from 'react';
import OrbBall from '../../../components/OrbBall/OrbBall';

export const QUESTION_CHAR_LIMIT = 140;

const TYPING_IDLE_MS = 1200;

export default function QuestionInput({ question, onChange, onSubmit }) {
  const trimmed = question.trim();
  const [typing, setTyping] = useState(false);
  const typingTimer = useRef(null);

  // The orb leans in while the player types and settles once they pause.
  useEffect(() => () => clearTimeout(typingTimer.current), []);

  const handleChange = (value) => {
    onChange(value);
    setTyping(true);
    clearTimeout(typingTimer.current);
    typingTimer.current = setTimeout(() => setTyping(false), TYPING_IDLE_MS);
  };

  const expression = typing ? 'curious' : trimmed ? 'happy' : 'idle';

  return (
    <div className="orb-screen">
      <div className="orb-rule">What do you want to know?</div>

      <div className="orb-question-orb">
        <OrbBall
          mood="default"
          size={190}
          showBase={false}
          expression={expression}
          intensity={typing ? 2 : 0}
          ariaLabel="The orb waits for your question"
        />
      </div>

      <div className="orb-card" style={{ display: 'flex', flexDirection: 'column' }}>
        <textarea
          className="orb-textarea"
          value={question}
          maxLength={QUESTION_CHAR_LIMIT}
          placeholder="Will I get that promotion?"
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && trimmed) {
              e.preventDefault();
              onSubmit();
            }
          }}
          autoFocus
        />
        <span className="orb-char-count">{question.length}/{QUESTION_CHAR_LIMIT}</span>
      </div>

      <button
        type="button"
        className="orb-btn"
        style={{ marginTop: 22 }}
        onClick={onSubmit}
        disabled={!trimmed}
      >
        Summon Your Answer ✦
      </button>

      <div className="orb-tip">
        <span aria-hidden="true">🪶</span>
        <div>
          <strong>Tip</strong>
          The more energy you send, the more the Orb feels your intent.
        </div>
      </div>

      <div className="orb-spacer" />
    </div>
  );
}
